<template>
    <div>
        <div id="contribute" class="wrapper m0-50 critical mb-50">
            <div class="section">
                <div class="div-block-15">
                    <div class="columns-7 w-row">
                        <div class="w-col w-col-9 w-col-stack" data-ix="new-interaction">
                            <div class="content4-headline-wrap">
                                <h6><strong class="bold-text-3">How to Contribute</strong></h6>
                                <div class="size1-text size1-top-clear available">Support the Platform</div>
                                <ul class="list">
                                    <li>Improve supply chain visibility for medical goods in Canada during COVID-19</li>
                                    <li>Present your brand as a platform contributor to an audience of suppliers, manufacturers, retailers, and medical professionals</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="support-type top">Cash Donations</div>
                    <ul class="list">
                        <li>Donations will be used to cover the development costs associated with expanding and maintaining the product catalog available through the Rapid Response Platform</li>
                        <li>All additional funds will be used to procure high-demand medical goods for those who need them most</li>
                    </ul>
                    <div class="support-type">In-kind Donations</div>
                    <ul class="list">
                        <li>Expanding our product library requires input from end-product users, end-product manufacturers, and input material manufacturers to ensure our questionnaires and matching criteria are effective</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ContactUs",
        created () {
            document.title = "Contact Us";
        },
    }
</script>

<style scoped>

</style>
